import React, { useEffect, useState } from "react";
import GlobalHeader from "../../components/header";
import Footer from "../../components/footer";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  Pagination,
  Skeleton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ContainerCardsOwn from "../../components/ContainerCardsOwn";
import useSnack from "../../hooks/useSnack";
import useApi from "../../hooks/useApi";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Euro } from "@mui/icons-material";
import PercentIcon from "@mui/icons-material/Percent";
import { validateMinMaxIsValid } from "../../utils/validations";
import SnackAlert from "../../components/SnackAlert";

function Projects() {
  const [mainPropertyData, setMainPropertyData] = useState([]);
  const [paginatedData, setPaginatedData] = useState(false);
  const [filteredData, setFilteredData] = useState(false);
  const [locationList, setLocationList] = useState([]);
  const [searchQuery, setSearchQuery] = useState(() => {
    const savedFilters = sessionStorage.getItem('projectFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      return filters.search || "";
    }
    return "";
  });

  // STATES
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [anchorEl, setAnchorEl] = useState(null);
  const [expanded, setExpanded] = useState("");
  const openMenuOrderBy = Boolean(anchorEl);

  // SETTINGS
  const [filtersSettings, setFiltersSettings] = useState(() => {
    const savedFilters = sessionStorage.getItem('projectFilters');
    return savedFilters ? JSON.parse(savedFilters) : {
      price: { min: "", max: "" },
      profitability: { min: "", max: "" },
      days: { min: "", max: "" },
      objective: { min: "", max: "" },
      search: ""
    };
  });

  const [page, setPage] = useState(1);
  const ITEMS_PER_PAGE = 9;

  const GetProjects = async () => {
    setOpenBackDrop(true);
    loadApi("home/projects", true, "get")
      .then((response) => {
        if (response.data) {
          setFilteredData(response.data);
          setMainPropertyData(response.data);
          return;
        }
        let locationsTemp = response.data.map((x) => x.location);
        locationsTemp = locationsTemp.filter(
          (n, index) => locationsTemp.indexOf(n) === index
        );
        setLocationList(locationsTemp);
        setPaginatedData(
          response.data.slice(
            (page - 1) * ITEMS_PER_PAGE,
            page * ITEMS_PER_PAGE
          )
        );
        setMainPropertyData(response.data);
        setFilteredData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  };

  const applyFilters = (filters) => {
    let filteredData = mainPropertyData;

    if (filters.price.min || filters.price.max) {
      const result = validateMinMaxIsValid(
        filters.price.min,
        "Inversión mínima",
        filters.price.max,
        "Inversión máxima",
        showSnack
      );
      if (result) {
        filteredData = filteredData.filter(
          x => parseInt(x.min_investment) >= parseInt(filters.price.min) &&
            parseInt(x.min_investment) <= parseInt(filters.price.max)
        );
      }
    }

    if (filters.profitability.min || filters.profitability.max) {
      const result = validateMinMaxIsValid(
        filters.profitability.min,
        "Rentabilidad mínima",
        filters.profitability.max,
        "Rentabilidad máxima",
        showSnack
      );
      if (result) {
        filteredData = filteredData.filter(
          x => parseInt(x.esti_profitability) >= filters.profitability.min &&
            parseInt(x.esti_profitability) <= filters.profitability.max
        );
      }
    }

    if (filters.objective.min || filters.objective.max) {
      const result = validateMinMaxIsValid(
        filters.objective.min,
        "Objetivo mínimo",
        filters.objective.max,
        "Objetivo máximo",
        showSnack
      );
      if (result) {
        filteredData = filteredData.filter(
          x => parseInt(x.objective) >= filters.objective.min &&
            parseInt(x.objective) <= filters.objective.max
        );
      }
    }

    if (filters.search) {
      filteredData = Searcher(filteredData, filters.search);
    }

    setFilteredData(filteredData);
  };

  const Searcher = (mainData, filterQuery) => {
    let tempQuery = filterQuery.toLowerCase();
    let response = mainData.filter((x) =>
      x.name.toLowerCase().includes(tempQuery)
    );
    return response;
  };

  const handlerChangeExpanded = (target) => {
    if (target === expanded) {
      setExpanded("main");
      return;
    }
    setExpanded(target);
  };

  const handlerFilterSet = () => {
    const mockUpData = {
      price: { min: "", max: "" },
      profitability: { min: "", max: "" },
      days: { min: "", max: "" },
      objective: { min: "", max: "" },
      search: ""
    };

    let hasValidFilters = false;

    if (JSON.stringify(filtersSettings) !== JSON.stringify(mockUpData)) {
      sessionStorage.setItem('projectFilters', JSON.stringify(filtersSettings));
      hasValidFilters = true;
    }

    applyFilters(filtersSettings);
    setOpenDrawer(false);
    showSnack("Filtro aplicado", "success");
  };

  const handlerResetFilters = () => {
    const defaultFilters = {
      price: { min: "", max: "" },
      profitability: { min: "", max: "" },
      days: { min: "", max: "" },
      objective: { min: "", max: "" },
      search: ""
    };

    setFiltersSettings(defaultFilters);
    setSearchQuery("");
    sessionStorage.removeItem('projectFilters');
    setFilteredData(mainPropertyData);
    showSnack("Filtro restablecido", "success");
  };

  const formatNumberWithDots = (number) => {
    if (typeof number === "number") {
      number = `${number}`;
    }
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");
    return rawValue;
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (!filteredData) return;
    let tempData = filteredData.slice(
      (page - 1) * ITEMS_PER_PAGE,
      page * ITEMS_PER_PAGE
    );
    setPaginatedData(tempData);
  }, [filteredData, page]);

  useEffect(() => {
    const newFiltersSettings = {
      ...filtersSettings,
      search: searchQuery
    };

    setFiltersSettings(newFiltersSettings);
    sessionStorage.setItem('projectFilters', JSON.stringify(newFiltersSettings));
    applyFilters(newFiltersSettings);
  }, [searchQuery]);


  useEffect(() => {
    if (mainPropertyData.length > 0) {
      const savedFilters = sessionStorage.getItem('projectFilters');
      if (savedFilters) {
        const filters = JSON.parse(savedFilters);
        applyFilters(filters);
        setSearchQuery(filters.search || "");
      }
    }
  }, [mainPropertyData]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    GetProjects();
  }, []);
  return (
    <>
      <GlobalHeader />
      <Stack
        component="main"
        sx={{
          minHeight: "calc(100vh - 80px)",
          width: { xs: "98vw", md: "90vw", lg: "80vw", xl: "75vw" },
          marginInline: "auto",
          pt: 10,
        }}
      >
        <Stack sx={{ px: { xs: 2.5, md: 3 } }}>
          <Stack
            component="header"
            sx={{
              width: "100%",
              marginInline: "auto",
              justifyContent: "space-between",
              gap: 2,
              mb: 4,
            }}
          >
            <Typography
              component="span"
              fontSize="small"
              sx={{
                backgroundColor: "#E5E7EB",
                color: "#474747",
                py: 0.5,
                px: 2,
                width: "fit-content",
                borderRadius: 3,
                fontWeight: 400,
              }}
            >
              Encuentra tu próximo proyecto
            </Typography>
            <Typography
              component="h1"
              variant="h3"
              sx={{
                fontWeight: 700,
                fontFamily: "Inter",
                width: { xs: "95%", md: "60%", lg: "70%", xl: "85%" },
                letterSpacing: 0,
              }}
            >
              Descubre oportunidades emocionantes
            </Typography>

            <Typography
              component="span"
              sx={{
                fontSize: "large",
                fontWeight: 400,
                color: "GrayText",
                mb: 1.5,
                width: { xs: "95%", md: "50%" },
              }}
            >
              Explora una amplia variedad de proyectos interesantes en
              diferentes categorías, presupuestos.
            </Typography>
            <TextField
              value={searchQuery}
              onChange={({ target }) => {
                setSearchQuery(target.value);
              }}
              placeholder="Buscar proyectos por nombre..."
              sx={{
                width: { xs: "80%", md: "40%", lg: "30%" },
              }}
              inputProps={{
                style: {
                  padding: "6px 2px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
          <Stack
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              mb: 8,
              gap: 5,
            }}
          >
            <Box
              sx={{
                width: "25%",
                pt: 3,
                display: { xs: "none", md: "initial" },
              }}
            >
              <Stack
                sx={{
                  position: "sticky",
                  top: 0,
                  fontFamily: "Inter !important",
                }}
              >
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={() => {
                    handlerChangeExpanded("panel1");
                  }}
                  sx={{
                    background: "transparent",
                    boxShadow: "none",
                    borderRadius: 0,
                  }}
                >
                  <AccordionSummary
                    expandIcon={<KeyboardArrowUpIcon />}
                    id="panel-header"
                    aria-controls="panel-content"
                    sx={{ px: 0 }}
                  >
                    Inversión mínima
                  </AccordionSummary>
                  <AccordionDetails sx={{ px: 0 }}>
                    <Stack
                      flexDirection="row"
                      sx={{ fontSize: "small", fontWeight: 400 }}
                    >
                      <Stack>
                        <TextField
                          aria-label="Input-min-price"
                          label="Minimo"
                          type="text"
                          autoComplete="off"
                          value={formatNumberWithDots(
                            filtersSettings.price.min
                          )}
                          onChange={({ target }) => {
                            let result = handleChange(target.value);
                            if (/^\d*$/.test(result)) {
                              result = result.slice(0, 10);
                              setFiltersSettings({
                                ...filtersSettings,
                                price: {
                                  ...filtersSettings.price,
                                  min: result ? parseFloat(result) : "",
                                },
                              });
                            }
                          }}
                          sx={{
                            mb: 2,
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Euro fontSize="small" />
                              </InputAdornment>
                            ),
                          }}
                        />
                        <TextField
                          aria-label="Input-max-price"
                          label="Máximo"
                          type="text"
                          autoComplete="off"
                          value={formatNumberWithDots(
                            filtersSettings.price.max
                          )}
                          onChange={({ target }) => {
                            let result = handleChange(target.value);
                            if (/^\d*$/.test(result)) {
                              result = result.slice(0, 10);
                              setFiltersSettings({
                                ...filtersSettings,
                                price: {
                                  ...filtersSettings.price,
                                  max: result ? parseFloat(result) : "",
                                },
                              });
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Euro fontSize="small" />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Stack>
                    </Stack>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={() => {
                    handlerChangeExpanded("panel2");
                  }}
                  sx={{
                    background: "transparent",
                    boxShadow: "none",
                    borderRadius: 0,
                  }}
                >
                  <AccordionSummary
                    expandIcon={<KeyboardArrowUpIcon />}
                    id="panel-header"
                    aria-controls="panel-content"
                    sx={{ px: 0 }}
                  >
                    Rentabilidad
                  </AccordionSummary>
                  <AccordionDetails sx={{ px: 0 }}>
                    <Stack>
                      <TextField
                        aria-label="Input-min-profiabilty"
                        label="Minimo"
                        type="text"
                        autoComplete="off"
                        value={formatNumberWithDots(filtersSettings.profitability.min)}
                        onChange={({ target }) => {
                          let result = handleChange(target.value);
                          if (/^\d*$/.test(result)) {
                            result = result.slice(0, 10);
                            setFiltersSettings({
                              ...filtersSettings,
                              profitability: {
                                ...filtersSettings.profitability,
                                min: result ? parseFloat(result) : "",
                              },
                            });
                          }
                        }}
                        sx={{
                          mb: 2,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <PercentIcon fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />

                      <TextField
                        aria-label="Input-max-profiability"
                        label="Máximo"
                        type="text"
                        autoComplete="off"
                        value={formatNumberWithDots(filtersSettings.profitability.max)}
                        onChange={({ target }) => {
                          let result = handleChange(target.value);
                          if (/^\d*$/.test(result)) {
                            result = result.slice(0, 10);
                            setFiltersSettings({
                              ...filtersSettings,
                              profitability: {
                                ...filtersSettings.profitability,
                                max: result ? parseFloat(result) : "",
                              },
                            });
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <PercentIcon fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Stack>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={() => {
                    handlerChangeExpanded("panel3");
                  }}
                  sx={{
                    background: "transparent",
                    boxShadow: "none",
                    borderBottom: "1px solid #c2c2c29e",
                    borderRadius: 0,
                  }}
                >
                  <AccordionSummary
                    expandIcon={<KeyboardArrowUpIcon />}
                    id="panel-header"
                    aria-controls="panel-content"
                    sx={{ px: 0 }}
                  >
                    Objetivo
                  </AccordionSummary>
                  <AccordionDetails sx={{ px: 0 }}>
                    <Stack>
                      <TextField
                        aria-label="Input-min-objective"
                        label="Minimo"
                        type="text"
                        autoComplete="off"
                        value={formatNumberWithDots(
                          filtersSettings.objective.min
                        )}
                        onChange={({ target }) => {
                          let result = handleChange(target.value);
                          if (/^\d*$/.test(result)) {
                            result = result.slice(0, 10);
                            setFiltersSettings({
                              ...filtersSettings,
                              objective: {
                                ...filtersSettings.objective,
                                min: result ? parseFloat(result) : "",
                              },
                            });
                          }
                        }}
                        sx={{
                          mb: 2,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Euro fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <TextField
                        aria-label="Input-max-objective"
                        label="Máximo"
                        type="text"
                        autoComplete="off"
                        value={formatNumberWithDots(
                          filtersSettings.objective.max
                        )}
                        onChange={({ target }) => {
                          let result = handleChange(target.value);
                          if (/^\d*$/.test(result)) {
                            result = result.slice(0, 10);
                            setFiltersSettings({
                              ...filtersSettings,
                              objective: {
                                ...filtersSettings.objective,
                                max: result ? parseFloat(result) : "",
                              },
                            });
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Euro fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Stack>
                  </AccordionDetails>
                </Accordion>
                <Stack flexDirection="row" gap={1} mt={2}>
                  <Button
                    onClick={() => {
                      handlerResetFilters();
                      showSnack("Filtro restablecido", "success");
                    }}
                    sx={{ width: "100%" }}
                    size="small"
                  >
                    Restablecer
                  </Button>
                  <Button
                    variant="contained"
                    sx={{ width: "100%" }}
                    onClick={handlerFilterSet}
                    size="small"
                  >
                    Aplicar
                  </Button>
                </Stack>
              </Stack>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "75%" } }}>
              <Stack>
                {openBackDrop && mainPropertyData.length === 0 ? (
                  <Stack pt={3}>
                    <Grid container columns={2} spacing={2}>
                      <Grid item xs={2} md={1} lg={1}>
                        <Skeleton
                          variant="rectangular"
                          height={180}
                          sx={{ borderRadius: 3, mb: 1 }}
                        />
                        <Box>
                          <Skeleton height={25} width="80%" sx={{ mb: 1 }} />
                          <Skeleton height={30} width="100%" sx={{ mb: 1 }} />
                        </Box>
                        <Skeleton width="30%" height={60} />
                      </Grid>
                      <Grid item xs={2} md={1} lg={1}>
                        <Skeleton
                          variant="rectangular"
                          height={180}
                          sx={{ borderRadius: 3, mb: 1 }}
                        />
                        <Box>
                          <Skeleton height={25} width="80%" sx={{ mb: 1 }} />
                          <Skeleton height={30} width="100%" sx={{ mb: 1 }} />
                        </Box>
                        <Skeleton width="30%" height={60} />
                      </Grid>
                    </Grid>
                  </Stack>
                ) : (
                  <ContainerCardsOwn
                    types="project"
                    columns={2}
                    data={paginatedData}
                    childSizes={{ xs: 3, sm: 1.5, md: 1, lg: 1 }}
                    editButton={false}
                    detailsButton={true}
                    deleteButton={false}
                    showVerified={false}
                  />
                )}
              </Stack>
              <Stack>
                <Pagination
                  count={
                    filteredData.length
                      ? Math.ceil(filteredData.length / ITEMS_PER_PAGE)
                      : 0
                  }
                  sx={{ marginInline: "auto", mt: 4 }}
                  page={page}
                  onChange={handlePageChange}
                />
              </Stack>
            </Box>
          </Stack>
        </Stack>
      </Stack>
      <Footer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default Projects;